import styled from 'styled-components';
import { rem } from '../../utils/functions.js';
import { EXPANDABLE_PANEL_VARIANT } from './constants.js';
import { typography } from '../../typography/typography.js';

// Styled components for ExpandablePanel
var ExpandablePanelWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__ExpandablePanelWrapper",
  componentId: "sc-cozu3l-0"
})(["font-family:", ";line-height:", ";width:100%;box-sizing:border-box;background-color:", ";padding:", ";border:", ";color:", ";", ""], typography.fontFamily, typography.lineHeight, function (_ref) {
  var variant = _ref.variant,
    theme = _ref.theme;
  return variant === EXPANDABLE_PANEL_VARIANT.PRIMARY ? theme.colorPalette.neutralColors.light.shade_white : 'transparent';
}, function (_ref2) {
  var variant = _ref2.variant;
  return variant === EXPANDABLE_PANEL_VARIANT.PRIMARY ? '18px 20px' : '0';
}, function (_ref3) {
  var variant = _ref3.variant,
    theme = _ref3.theme;
  return variant === EXPANDABLE_PANEL_VARIANT.PRIMARY ? "1px solid ".concat(theme.colorPalette.neutralColors.light.shade_default) : 'none';
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_1;
}, function (_ref5) {
  var expandablePanelStyle = _ref5.expandablePanelStyle;
  return expandablePanelStyle;
});
process.env.NODE_ENV !== "production" ? ExpandablePanelWrapper.displayName = 'ExpandablePanelWrapper' : void 0;

// Styled components for Header
var HeaderWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__HeaderWrapper",
  componentId: "sc-cozu3l-1"
})(["cursor:pointer;width:100%;display:flex;align-items:start;vertical-align:middle;", ""], function (_ref6) {
  var headerWrapperStyle = _ref6.headerWrapperStyle;
  return headerWrapperStyle;
});
process.env.NODE_ENV !== "production" ? HeaderWrapper.displayName = 'HeaderWrapper' : void 0;
var HeaderTitle = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledComponents__HeaderTitle",
  componentId: "sc-cozu3l-2"
})(["display:inline-block;margin:3px 0 0 12px;font-size:", ";font-family:", ";font-weight:", ";", ""], rem(18), typography.fontFamily, function (_ref7) {
  var variant = _ref7.variant;
  return variant === EXPANDABLE_PANEL_VARIANT.PRIMARY ? typography.fontWeightDemibold : typography.fontWeightLight;
}, function (_ref8) {
  var titleStyle = _ref8.titleStyle;
  return titleStyle;
});
process.env.NODE_ENV !== "production" ? HeaderTitle.displayName = 'HeaderTitle' : void 0;

// Styled components for Body
var BodyWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__BodyWrapper",
  componentId: "sc-cozu3l-3"
})(["padding-top:12px;margin:0 0 10px;line-height:", ";transition:flex 0.3s ease-out;height:auto;display:", ";margin-left:", ";font-weight:300;", ""], rem(24), function (_ref9) {
  var isExpanded = _ref9.isExpanded;
  return isExpanded ? 'block' : 'none';
}, function (_ref10) {
  var variant = _ref10.variant;
  return variant === EXPANDABLE_PANEL_VARIANT.PRIMARY ? '32px' : '24px';
}, function (_ref11) {
  var bodyStyle = _ref11.bodyStyle;
  return bodyStyle;
});
process.env.NODE_ENV !== "production" ? BodyWrapper.displayName = 'BodyWrapper' : void 0;

export { BodyWrapper, ExpandablePanelWrapper, HeaderTitle, HeaderWrapper };
